import { render, staticRenderFns } from "./AppReviewPolicyTopLink.vue?vue&type=template&id=051ac490&scoped=true"
import script from "./AppReviewPolicyTopLink.vue?vue&type=script&lang=js"
export * from "./AppReviewPolicyTopLink.vue?vue&type=script&lang=js"
import style0 from "./AppReviewPolicyTopLink.vue?vue&type=style&index=0&id=051ac490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ac490",
  null
  
)

export default component.exports